export const STEPS_ORDER = ['delivery', 'contacts', 'payment'];

export const defaultModel = {
  id: 0,
  orderComment: '',
  step: 'delivery',
  description: '',
  payment: null,
  shop: null,
  delivery: null,
  infoUser: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    comment: '',
    agreement: true,
    legalEntity: false,
    consultation: false,
    record: false,
    seasonStorage: false,
    inn: '',
    bik: '',
    kpp: '',
    nameOrganization: '',
    addressOrganization: '',
    checkingAccount: '',
    receiveNotifications: false,
  },
  address: '',
  addComment: '',
  fiasId: '',
  fias: null,
  offerAkb: false,
  offerSecret: false,
  offerWiper: false,
  isValid: false,
};
